/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import SearchBox from '../containers/SearchBox';

import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';

// TODO: revisit this logic for PPLite countries
const links = {
  community: Page.getCommunityLink(),
  resolutionCenter: Page.getResolutionURL(),
};

const labels = {
  communitySmallScreen: i18n.message('smarthelp/heroSection.heroLinks.community.smallScreen'),
  communityLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.community.largeScreen'),

  resolutionSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.smallScreen'),
  resolutionLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.largeScreen'),

  helpcenterSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.helpcenter.smallScreen'),
  helpcenterLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.helpcenter.largeScreen'),

  emailSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.email.smallScreen'),
  emailLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.email.largeScreen'),
};

const cobrand = Page.getCountry();
const isSmcEnabled = Page.getIsSmcEnabled();

class HeroSection extends Component {
  static renderCommunityLink() {
    if (links.community) {
      return (
        <div className="link" id="hero-community-link">
          <a className="hero-hidden-xs" target="_blank" rel="noopener noreferrer" href={links.community}>{labels.communityLargeScreen}</a>
          <a className="visible-xs" target="_blank" rel="noopener noreferrer" href={links.community}>{labels.communitySmallScreen}</a>
        </div>
      );
    }
    return null;
  }

  static renderResolutionCenterLink() {
    if (links.resolutionCenter) {
      return (
        <div className="link" id="hero-resolution-link">
          <a className="hero-hidden-xs" target="_blank" href={links.resolutionCenter}>{labels.resolutionLargeScreen}</a>
          <a className="visible-xs" target="_blank" href={links.resolutionCenter}>{labels.resolutionSmallScreen}</a>
        </div>
      );
    }
    return null;
  }

  static renderMessageCenterLink(smcUrl) {
    if (isSmcEnabled) {
      return (
        <div className="link" id="hero-message-link">
          <a className="hero-hidden-xs" href={smcUrl}>{labels.emailLargeScreen}</a>
          <a className="visible-xs" href={smcUrl}>{labels.emailSmallScreen}</a>
        </div>
      );
    }
    return null;
  }
  render() {
    const helpCenterUrl = `/${cobrand}/selfhelp/home`;
    const returnUri = encodeURIComponent(`${Page.getBaseUrl()}/smc/customer`);
    const smcUrl = `/signin/?returnUri=${returnUri}`;
    const FPTIId = Page.getFPTIPageId();
    return (
      <div className="hero-section hero-section-container">
        <div className="search-box-container">
          <SearchBox FPTIId={FPTIId} />
        </div>
        <div className="hero-links">
          <div className="link" id="hero-help-link">
            <a className="hero-hidden-xs" href={helpCenterUrl}>{labels.helpcenterLargeScreen}</a>
            <a className="visible-xs" href={helpCenterUrl}>{labels.helpcenterSmallScreen}</a>
          </div>
          {HeroSection.renderCommunityLink()}
          {HeroSection.renderResolutionCenterLink()}
          {HeroSection.renderMessageCenterLink(smcUrl)}
        </div>
      </div>
    );
  }
}

export default HeroSection;
